/* eslint-disable react/prop-types */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var StackOverflow = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, 
    //	color = '#fff',
    //	strokeWidth = 2,
    _c = _a.styles, 
    //	color = '#fff',
    //	strokeWidth = 2,
    styles = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { style: __assign({ width: size }, styles), viewBox: "0 0 120 120", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: "st0", d: "M84.4 93.8V70.6h7.7v30.9H22.6V70.6h7.7v23.2z" }),
        React.createElement("path", { className: "st1", d: "M38.8 68.4l37.8 7.9 1.6-7.6-37.8-7.9-1.6 7.6zm5-18l35 16.3 3.2-7-35-16.4-3.2 7.1zm9.7-17.2l29.7 24.7 4.9-5.9-29.7-24.7-4.9 5.9zm19.2-18.3l-6.2 4.6 23 31 6.2-4.6-23-31zM38 86h38.6v-7.7H38V86z" })));
};
export default StackOverflow;
